import ConfigProvider from './context/PredictionConfigProviders'
import Predictions from './index'

const Prediction = () => {
  return (
    <ConfigProvider>
      <Predictions />
    </ConfigProvider>
  )
}

export default Prediction
